import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// GET /api/v1/teacher-payouts/?teacher={id}
// → [{ id, teacher, period_start, period_end, hours_total, amount_total, status, paid_at }]
// Contract: TASK-15 §8
function usePayoutHistory({ teacher } = {}) {
  return useQuery({
    queryKey: ["teacher-payouts", "history", { teacher }],
    queryFn: () =>
      apiClient
        .get("/api/v1/teacher-payouts/", { params: { teacher } })
        .then((r) => r.data),
    enabled: !!teacher,
  });
}

export { usePayoutHistory };
